class SiteDrawers extends window.BAO.CustomElement() {
  _activeDrawerKey = ''
  drawers = []

  MATCHES = {
    trigger: '[data-drawers-trigger]',
    subNav: '[data-drawers-sub-nav]',
    back: '[data-drawers-back]',
    close: '[data-drawers-close]',
    backdrop: '[data-site-drawers-el="backdrop"]',
    header: '[data-section-type="header"]',
  }

  ELS = {
    body: document.body || document.documentElement,
    backdrop: '[data-site-drawers-el="backdrop"]',
    drawers: document.querySelector('site-drawers'),
  }

  CLASSES = {
    activeClass: 'drw-Drawers-active',
    activeDrawerClass: 'drw-Drawer-active',
    siteOverflowed: 'util-SiteOverflowed',
    drawersOpenUtility: 'util-DrawersOpen',
  }

  constructor () {
    super()

    if (this.hasAlreadyBeenUsed) {
      throw new Error(
        `You can only use 1 instance of ${this.nodeName.toLowerCase()}`,
      )
    }

    window.drawers = this

    this.drawerKeys
      .filter(key => !this.triggerKeys.includes(key))
      .forEach(key =>
        console.info(`Drawer exists for ${key} but there is no trigger`),
      )
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.documentElement,
      'click',
      this.handleClick.bind(this),
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.MOBILE_QUICK_BUY.OPENED,
      this.additionalTriggerListeners.bind(this),
    )

    document.addEventListener('keydown', this.closeOnEsc.bind(this))

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.DRAWER.OPENED,
      this.focusActiveDrawer.bind(this),
    )
  }

  closeOnEsc (event) {
    if (event.key === 'Escape' || event.code === 'Escape') {
      const activeDrawer = document.querySelector(
        'site-drawer.drw-Drawer-active',
      )

      if (!activeDrawer) return

      this.isSubDrawerTrigger = false
      this.activeDrawerKey = ''
      this.parentDrawerKey = ''
    }
  }

  focusActiveDrawer (event) {
    const key = event.detail?.activeDrawerKey

    if (!key) return

    const drawer = document.querySelector(`site-drawer[key="${key}"]`)

    if (!drawer) return

    setTimeout(() => {
      if (typeof drawer.focus === 'function') {
        drawer.focus()
      }
    }, 250)
  }

  additionalTriggerListeners () {
    setTimeout(() => {
      const extraTriggerEl = document.querySelector(
        'product-quick-buy-mobile [data-drawers-trigger="back-in-stock"]',
      )

      if (extraTriggerEl) {
        this.listeners.add(extraTriggerEl, 'click', this.handleClick.bind(this))
      }
    }, 500)
  }

  handleClick (e) {
    const eventType = (() => {
      if (e.target.closest(this.MATCHES.trigger) !== null) {
        return 'TRIGGER'
      } else if (e.target.closest(this.MATCHES.back) !== null) {
        return 'BACK'
      } else if (e.target.closest(this.MATCHES.close) !== null) {
        return 'CLOSE'
      } else if (e.target.closest(this.MATCHES.backdrop) !== null) {
        return 'BACKDROP'
      } else if (e.target.closest(this.MATCHES.header) !== null) {
        return 'HEADER'
      }

      return 'UNKNOWN'
    })()

    if (eventType === 'HEADER') {
      this.isSubDrawerTrigger = false
      this.activeDrawerKey = ''
      this.parentDrawerKey = ''

      return
    }

    if (eventType === 'UNKNOWN') return
    e.preventDefault()

    if (eventType === 'TRIGGER') {
      const trigger = e.target.closest(this.MATCHES.trigger)
      const key = trigger.getAttribute('data-drawers-trigger')
      let hideDrawerIfSizeGuideAndDesktop = false

      if (key === 'size-guide') {
        const mediaQuery = window.matchMedia('(min-width: 900px)')
        hideDrawerIfSizeGuideAndDesktop = this.checkIfMediaWidth(mediaQuery)
      } else if (key === 'back-in-stock') {
        const mobileQuickbuy = document.querySelector(
          '[data-product-quick-buy-mobile-el="container"]',
        )

        if (mobileQuickbuy) {
          mobileQuickbuy.ariaHidden = 'true'
        }
      }

      if (hideDrawerIfSizeGuideAndDesktop) return

      this.isSubDrawerTrigger = e.target.closest(this.MATCHES.subNav)

      if (this.triggerKeys.includes(key)) {
        if (this.isSubDrawerTrigger) {
          this.parentDrawerKey = !this.parentDrawerKey
            ? this.activeDrawerKey
            : this.parentDrawerKey
          this.activeDrawerKey = key
        } else {
          this.activeDrawerKey =
            key === this.activeDrawerKey || key === this.parentDrawerKey
              ? ''
              : key
          this.parentDrawerKey = ''
        }
      }

      if (
        e.target.closest('button')?.hasAttribute('data-desktop-all-filters')
      ) {
        this.querySelectorAll(
          '[data-site-drawer-external-el="facet-summary"]',
        ).forEach(facetEl => {
          if (facetEl.parentNode.hasAttribute('open')) {
            facetEl.click()
          }
        })
      }

      this.getParentDrawers(trigger).forEach(parentDrawer => {
        parentDrawer.classList.add('drw-Drawer-active')
      })

      window.BAO.dispatchEvent(window.BAO.EVENTS.DRAWER.OPENED, {
        trigger,
        activeDrawerKey: this.activeDrawerKey,
      })
    }

    if (eventType === 'BACK') {
      const backButton = e.target.closest(this.MATCHES.back)
      const key = backButton.getAttribute('data-drawers-back')
      this.drawers
        .filter(drawer => drawer.key === key)
        .forEach(drawer => (drawer.isOpen = false))
    }

    if (eventType === 'CLOSE' || eventType === 'BACKDROP') {
      const closedDrawer = e.target.closest('.drw-Drawer')

      this.isSubDrawerTrigger = false
      this.activeDrawerKey = ''
      this.parentDrawerKey = ''
      this.closedDrawerKey = closedDrawer.getAttribute('key')

      window.BAO.dispatchEvent(window.BAO.EVENTS.DRAWER.CLOSED, {
        closedDrawerKey: this.closedDrawerKey,
      })
    }
  }

  checkIfMediaWidth (mediaQuery) {
    if (mediaQuery.matches) {
      return true
    } else {
      return false
    }
  }

  get triggerKeys () {
    return window.BAO.utils
      .getElements('[data-drawers-trigger]')
      .map(el => el.getAttribute('data-drawers-trigger'))
  }

  get drawerKeys () {
    return window.BAO.utils
      .getElements('[data-module-drawers-drawer]')
      .map(el => el.getAttribute('data-module-drawers-drawer'))
  }

  get hasAlreadyBeenUsed () {
    const el = window.BAO.utils.getElement(this.nodeName.toLowerCase())

    return el !== this
  }

  get aDrawerIsOpen () {
    return this.drawers.some(drawer => drawer.isOpen)
  }

  get activeDrawerKey () {
    return this._activeDrawerKey
  }

  set activeDrawerKey (key) {
    if (!this.isSubDrawerTrigger) {
      document.body.classList.remove(`drw-Drawers-${this.activeDrawerKey}`)
      document.body.classList.remove(`drw-Drawers-${this.parentDrawerKey}`)

      if (key !== '') {
        document.body.classList.add(`drw-Drawers-${key}`)
      }

      if (this.activeDrawerKey === 'collectionfilters') {
        this.availableFilters()
      }
    }

    this._activeDrawerKey = key

    this.drawers.forEach(drawer => (drawer.isOpen = drawer.key === key))

    if (!this.isSubDrawerTrigger) {
      this.ELS.drawers.classList.toggle(
        this.CLASSES.activeClass,
        this.aDrawerIsOpen,
      )
      document.body.classList.toggle(
        this.CLASSES.siteOverflowed,
        this.aDrawerIsOpen,
      )
      document.body.classList.toggle(
        this.CLASSES.drawersOpenUtility,
        this.aDrawerIsOpen,
      )

      if (key !== '') {
        this.els.drawer.element.classList.add('drw-Drawers_Drawer-active')
        document.body.classList.add(`drw-Drawers-${key}`)
      } else {
        this.els.drawer.element.classList.remove('drw-Drawers_Drawer-active')
      }
    }
  }

  availableFilters () {
    const filterToolbar = document.getElementById('ToolbarFiltersForm')

    let loopIndex = 0

    this.querySelectorAll(
      '[data-site-drawer-external-el="facet-summary"]',
    ).forEach(facetEl => {
      if (loopIndex < 6) {
        const facetElIndex = facetEl.getAttribute('data-index')

        switch (
          facetEl
            .closest('[data-collection-filters-el]')
            .getAttribute('aria-hidden')
        ) {
          case 'true':
            filterToolbar.querySelector(
              `[data-site-drawer-external-el="facet-item"][data-index="${facetElIndex}"]`,
            ).style.display = 'none'
            break
          case 'false':
            filterToolbar.querySelector(
              `[data-site-drawer-external-el="facet-item"][data-index="${facetElIndex}"]`,
            ).style.display = 'block'
            break
        }
      }
      loopIndex++
    })
  }

  getParentDrawers (trigger) {
    const drawerKeys = trigger.dataset.drawersParentKeys
      ? trigger.dataset.drawersParentKeys.split(',')
      : []
    return drawerKeys.map(drawerKey => {
      return window.BAO.utils.getElement(`[key="${drawerKey}"]`, this)
    })
  }
}

customElements.define('site-drawers', SiteDrawers)
